import styles from '../styles/cartcheckout.module.css'
import { useState } from 'react';

import Checkout from '../components/Checkout';


const CartCheckout = () => {

    return (
        <div className={styles.maincartcheckout}>
            <Checkout/>
        </div>
    )
}

export default CartCheckout;